// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__gAbJe","actions":"GroupTable_actions__iPE_l","deleteModalFooter":"GroupTable_deleteModalFooter__3H4Yx"};